// extracted by mini-css-extract-plugin
export default {"gameFeedContent":"styles_gameFeedContent__fCMRY","icon":"styles_icon__woX19","content":"styles_content__Zrobw"};